<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "FluxOms",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  